import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "vpt-cookie-consent";

const applyConsent = (value) => {
  try {
    if (window.posthog) {
      if (value === "accepted") window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    }
  } catch (e) {
    /* posthog not ready — ignore */
  }
};

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      setVisible(true);
    } else {
      applyConsent(saved);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    applyConsent(value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookie-Einwilligung"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 inset-x-0 z-[9998] p-4 md:p-6"
        >
          <div className="max-w-5xl mx-auto bg-[#0d0d0d] border border-white/15 shadow-[0_0_40px_rgba(0,0,0,0.6)]">
            <div className="p-6 md:p-8 flex flex-col lg:flex-row lg:items-center gap-6">
              <div className="flex items-start gap-4 flex-1">
                <div className="h-11 w-11 shrink-0 grid place-items-center border border-primary/40 text-primary">
                  <Cookie className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="font-display uppercase tracking-wide text-lg text-white mb-1">
                    Wir respektieren deine Privatsphäre
                  </h3>
                  <p className="text-sm text-white/55 leading-relaxed">
                    Wir verwenden notwendige Cookies für den Betrieb der Seite sowie optionale
                    Analyse-Cookies, um unser Angebot zu verbessern. Details findest du in unserer{" "}
                    <Link to="/datenschutz" className="text-primary hover:underline">Datenschutzerklärung</Link>.
                  </p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 shrink-0">
                <button
                  data-testid="cookie-reject"
                  onClick={() => choose("rejected")}
                  className="border border-white/20 text-white font-display font-bold uppercase tracking-wider text-sm px-6 py-3 hover:border-white/50 transition-colors duration-300"
                >
                  Nur notwendige
                </button>
                <button
                  data-testid="cookie-accept"
                  onClick={() => choose("accepted")}
                  className="bg-primary text-primary-foreground font-display font-bold uppercase tracking-wider text-sm px-6 py-3 hover:bg-white transition-colors duration-300"
                >
                  Alle akzeptieren
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
